import { Component } from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {VehicleProvider} from "../../providers/vehicle/vehicle";
import {BarcodeScanner} from '@ionic-native/barcode-scanner';
import {ToastProvider} from "../../providers/toast/toast";
import {Camera, CameraOptions} from '@ionic-native/camera';
import {SearchListItemPage} from "../search-list-item/search-list-item";
import {ErrorListProvider} from "../../providers/error-list/error-list";

/**
 * Generated class for the VehiclePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vehicle',
  templateUrl: 'vehicle.html',
})
export class VehiclePage {
  salesOrder: any = {};
  vehicles: any = [];
  vehicleNumber: any = null;
  vehicle: any = null;
  inspectedVehiclesCount: number = 0;
  openVehiclesCount: number = 0;
  images: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toast: ToastProvider,
    private barcodeScanner: BarcodeScanner,
    private camera: Camera,
    private loadingCtrl: LoadingController,
    private vehicleProvider: VehicleProvider,
    private errorListProvider: ErrorListProvider
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
  }

  ionViewDidLoad() {
    this.loadVehicles();
  }

  ionViewDidEnter() {
    if (this.errorListProvider.selectedErrorList != null) {
      if (this.errorListProvider.insertErrorListMode == 'NA') {
        this.vehicle.mostly_ok_list = this.errorListProvider.selectedErrorList;
      } else if (this.errorListProvider.insertErrorListMode == 'NIO') {
        this.vehicle.error_list = this.errorListProvider.selectedErrorList;
      } else if (this.errorListProvider.insertErrorListMode == 'NA-sub') {
        this.vehicle.vehicle_mostly_ok_list.push({
          id: 0,
          mostly_ok_list: [this.errorListProvider.selectedErrorList]
        });
      } else if (this.errorListProvider.insertErrorListMode == 'NIO-sub') {
        this.vehicle.vehicle_error_list.push({
          id: 0,
          error_list: [this.errorListProvider.selectedErrorList]
        });
      }

      this.errorListProvider.selectedErrorList = null;
    }
  }

  async loadVehicles() {
    this.inspectedVehiclesCount = 0;
    this.openVehiclesCount = 0;

    this.vehicleProvider.get(this.salesOrder.name).then(data => {
      this.vehicles = data;

      for (let vehicle of this.vehicles.results) {
        if (vehicle.user_id > 0) {
          this.inspectedVehiclesCount ++;
        }
      }

      this.openVehiclesCount = this.vehicles.results.length - this.inspectedVehiclesCount;
    });
  }

  scanVehicle() {
    this.barcodeScanner.scan().then(barcodeData => {
      this.vehicleNumber = barcodeData.text;

      this.vehicleNumber = this.modifyVehicleNumber(this.vehicleNumber);

      if (!this.vehicleNumber || this.vehicleNumber.length == 0) {
        this.toast.error('Bitte geben Sie eine Fahrzeugnummer ein.');

        return;
      }

      this.startVehicle()
      // this.toast.info('Detected barcode: '+barcodeData);
    }).catch(err => {
      this.toast.error('Barcode kann nicht gelesen werden. Fehler: '+err);
    });
  }

  modifyVehicleNumber(vehicleNumber: any) {
    // Check for need of modification
    if (this.salesOrder.modify_vehicle_numbers) {
      // Delete first letter if the vehicle number is not a integer
      if (!parseInt(vehicleNumber)) {
        vehicleNumber = vehicleNumber.substring(1, vehicleNumber.length);
      }

      if (this.vehicleNumber.length > 3) {
        vehicleNumber = vehicleNumber.substring(0, vehicleNumber.length -3);
      }
    }

    return vehicleNumber;
  }

  startVehicle() {
    if (!this.vehicleNumber || this.vehicleNumber.length == 0) {
      this.toast.error('Bitte geben Sie eine Fahrzeugnummer ein.');

      return;
    }

    this.images = [];

    this.vehicle = this.findVehicle(this.vehicleNumber);

    if (this.vehicle == null) {
      //this.vehicleNumber = this.modifyVehicleNumber(this.vehicleNumber);

      this.vehicle = {
        id: 0,
        sub_order_no: this.vehicleNumber,
        create_type: 'app',
        io: false,
        sale_id: this.salesOrder.id,
        comment: '',
        error_list: { id: 0, error_no: '', error_name: '' },
        mostly_ok_list: { id: 0, error_no: '', error_name: '' },
        vehicle_mostly_ok_list: [],
        vehicle_error_list: [],
      }
    } else {
      this.loadImages();
    }
  }

  async loadImages() {
    this.vehicleProvider.getImages(this.vehicle.id).then(data => {
      // @ts-ignore
      this.images = data.results;

      if (typeof this.images.length == 'undefined') this.images = [];
    });
  }

  makePicture() {
    const options: CameraOptions = {
      quality: 90,
      targetWidth: 1920,
      targetHeight: 1080,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      correctOrientation: true
    };

    this.camera.getPicture(options).then((imageData) => {
      this.images.push({
        id: 0,
        file: imageData
      });
    }, (err) => {
      // Handle error
      alert("Fehler: "+err);
    });
  }

  private findVehicle(vehicleNumber: any) {
    if (!vehicleNumber || vehicleNumber.length == 0)
      return null;

    for (let vehicle of this.vehicles.results) {
      if (vehicle.sub_order_no == vehicleNumber) {
        return vehicle;
      }
    }
    return null;
  }

  async saveVehicle() {
    if (!this.vehicle.io) {
      if (this.vehicle.mostly_ok_list.id == 0 && this.vehicle.error_list.id == 0) {
        this.toast.error('Zum Abschließen muss das Fahrzeug als "In Ordnung" markiert werden, oder Nacharbeiten bzw. Fehler einegeben werden.');

        return;
      }
    }

    let loading = this.loadingCtrl.create({content: "Fahrzeugbericht wird gespeichert, bitte warten ..."});
    loading.present();

    await this.vehicleProvider.save(this.vehicle, this.images);

    this.vehicle = null;
    this.vehicleNumber = "";
    this.images = [];

    this.loadVehicles();

    loading.dismiss();
  }

  goToSearchListItem(mode) {
    this.errorListProvider.insertErrorListMode = mode;

    this.navCtrl.push(SearchListItemPage, {
      mode: mode,
      salesOrder: this.salesOrder
    });
  }

  removeMostlyOkItem(index) {
    this.vehicle.vehicle_mostly_ok_list.splice(index, 1);
  }

  removeErrorItem(index) {
    this.vehicle.vehicle_error_list.splice(index, 1);
  }

}



// WEBPACK FOOTER //
// ./src/pages/vehicle/vehicle.ts